import React, { useState, useEffect } from 'react';
import { supabase } from '../../utils/supabaseClient';

export default function TabEmail({ topic, contentId, content, includeText }) {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  useEffect(() => {
    const fetchEmail = async () => {
      if (!contentId) return;

      const { data, error } = await supabase
        .from('generated_email')
        .select('subject, body')
        .eq('content_id', contentId);

      if (error) {
        console.error('Failed to fetch email:', error);
        return;
      }

      if (data.length > 0) {
        const email = data[0];
        setSubject(email.subject || '');
        setBody(email.body || '');
      } else {
        setSubject('');
        setBody('');
      }
    };

    fetchEmail();
  }, [contentId]);

  const generateContent = async () => {
    if (!topic) {
      alert('Topic is required.');
      return;
    }

    if (!contentId) {
      alert('Content ID is missing. Cannot save email.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch('/api/generate-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          content,
          includeText,
        }),
      });

      const data = await res.json();

      if (!data.success) {
        alert(data.error || 'Failed to generate email.');
        return;
      }

      setSubject(data.subject);
      setBody(data.body);

      await supabase
        .from('generated_email')
        .delete()
        .eq('content_id', contentId);

      const { error } = await supabase.from('generated_email').insert([
        {
          content_id: contentId,
          subject: data.subject,
          body: data.body,
        },
      ]);

      if (error) {
        console.error('Failed to save email:', error);
      }
    } catch (err) {
      console.error(err);
      alert('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-output view-content pb-100-d">
      <h2>Generate Email Copy</h2>

      <div className="content-actions justify-left">
        <button
          type="button"
          className="btn cici-think mt-0"
          onClick={generateContent}
          disabled={loading || !topic || !contentId}
        >
          {loading ? 'Generating…' : 'Generate Content'}
        </button>
      </div>

      <h2>Email Copy Output</h2>

      <div className="output-section">
        <label>Subject:</label>
        <div className="output-value">
          <input
            type="text"
            readOnly
            value={subject}
          />
          <button
            className="btn-unset"
            type="button"
            onClick={() => copyToClipboard(subject)}
            disabled={!subject}
          >
            <i className="bi bi-copy" />
          </button>
        </div>
      </div>

      <div className="output-section">
        <label>Email Body:</label>
        <div className="output-value">
          <textarea
            readOnly
            value={body}
          />
          <button
            className="btn-unset"
            type="button"
            onClick={() => copyToClipboard(body)}
            disabled={!body}
          >
            <i className="bi bi-copy" />
          </button>
        </div>
      </div>
    </div>
  );
}